import { lazy } from 'react'

const AgGridReactLazy = lazy(() => import('./imports'))

export default AgGridReactLazy
